import React from 'react';
import Menu from './Menu';
import { MenuItem } from './MenuItem';

interface RunMenuProps {
  items: MenuItem[];
}

const RunMenu: React.FC<RunMenuProps> = ({ items }) => {
  return <Menu items={items} />;
};

export default RunMenu; 